var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      minWidth: 60
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.67 354.67"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 403.11,
    y1: 477.84,
    x2: 403.11,
    y2: 714.12,
    gradientTransform: "rotate(-15.25 -1271.853 1229.872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14fdee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01d0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 355.36,
    y1: 671.84,
    x2: 393.92,
    y2: 671.84,
    gradientTransform: "rotate(-15.25 -1271.853 1229.872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0080af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33b0cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__c",
    x1: 353.65,
    y1: 542.43,
    x2: 535.01,
    y2: 580.98,
    xlinkHref: "#logo_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__d",
    x1: 356.77,
    y1: 617.02,
    x2: 458.4,
    y2: 617.02,
    xlinkHref: "#logo_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m135.63 206.11.26.11h.07Zm-7.1-4.83c-.27-.28-.54-.57-.8-.87.27.3.53.59.8.87Zm0 0 .18.2.45.43.11.11.38.34.21.19.43.36c.25.2.49.4.75.59l.53.38c.18.14.37.26.57.39l.14.09a6.1 6.1 0 0 0 .54.34q.31.2.63.36l.47.25c.21.12.43.23.65.33l.67.3a21.92 21.92 0 0 1-6.71-4.66Zm7.36 4.94h.07l-.33-.14Zm-7.36-4.94.18.2.45.43.11.11.38.34.21.19.43.36c.25.2.49.4.75.59l.53.38c.18.14.37.26.57.39l.14.09a6.1 6.1 0 0 0 .54.34q.31.2.63.36l.47.25c.21.12.43.23.65.33l.67.3a21.92 21.92 0 0 1-6.71-4.66Zm0 0c-.27-.28-.54-.57-.8-.87.27.3.53.59.8.87ZM285.78 119c-8.56-8.79-15.94-17.38-29.5-13.79l-124.87 34.03c-18.48 5.2-34.23-15-24.19-31.39a20.92 20.92 0 0 1 7-7.07 20.42 20.42 0 0 1 4.61-2.16c1.17-.43 113.51-30.95 114.77-31.33a56 56 0 0 0-52.76-12.94l-69 18.82a56 56 0 0 0-39.4 39.75l-18.22 69.2a56 56 0 0 0 14.72 54c81.13 81 63.48 76.4 174 45.8a56 56 0 0 0 39.4-39.74L300.5 173a56 56 0 0 0-14.72-54Zm-138 151s-.05 0-.05-.05a21.17 21.17 0 0 1-6.31-11.95 8.52 8.52 0 0 1-.14-1 21.4 21.4 0 0 1 12.49-21.86c.32-.14.63-.28 1-.4a21.18 21.18 0 0 1 13.48-.61s0 0 .08 0a21.31 21.31 0 0 1 6.06 2.86A22.11 22.11 0 0 1 177 239s.05 0 .06.06a21.29 21.29 0 0 1 6.12 10.94c.08.34.15.69.2 1 .06.34.1.69.14 1A21.42 21.42 0 0 1 171 273.92a10.2 10.2 0 0 1-1 .4 21.28 21.28 0 0 1-13.49.61s-.05 0-.07 0a21.26 21.26 0 0 1-8.69-5Zm84.13-99.3a21.37 21.37 0 0 1-15.54 18.3l-66.46 18.12h-.16c-.38.11-.77.2-1.16.28l-.43.08a20.73 20.73 0 0 1-5.32.32c-.29 0-.59 0-.87-.07a8.62 8.62 0 0 1-.87-.11c-.29 0-.58-.08-.87-.14l-.83-.17c-.47-.1-.92-.22-1.38-.36l-.7-.22c-.23-.08-.46-.15-.68-.24l-.6-.23-.33-.14-.18-.08-.25-.11a21.8 21.8 0 0 1-6.67-4.64c-.27-.28-.54-.57-.8-.87a5.12 5.12 0 0 1-.36-.43c-.12-.14-.24-.29-.35-.44s-.24-.32-.36-.48-.28-.37-.41-.57a.44.44 0 0 1-.08-.11 1.3 1.3 0 0 1-.1-.15 19.85 19.85 0 0 1-2.68-6 21.29 21.29 0 0 1 14.92-26.11L204.78 148c11-3.22 23.7 3.57 26.51 14.81a20 20 0 0 1 .64 7.84Zm-96.3 35.46.26.11h.07Zm-7.1-4.83.18.2.45.43.11.11.38.34.21.19.43.36c.25.2.49.4.75.59l.53.38c.18.14.37.26.57.39l.14.09a6.1 6.1 0 0 0 .54.34q.31.2.63.36l.47.25c.21.12.43.23.65.33l.67.3a21.92 21.92 0 0 1-6.69-4.71Zm0 0c-.27-.28-.54-.57-.8-.87.29.25.55.54.82.82Z",
    style: {
      fill: "url(#logo_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25 252.59c.08.35.15.7.2 1 .07.35.1.69.14 1.05a21.58 21.58 0 0 1-12.59 22c-.32.14-.64.29-1 .4a21.47 21.47 0 0 1-13.6.61s-.06 0-.08 0a21.75 21.75 0 0 1-7.17-3.66 21.3 21.3 0 0 0 2.32.82s0 0 .07 0a21.28 21.28 0 0 0 13.49-.61 10.2 10.2 0 0 0 1-.4 21.42 21.42 0 0 0 12.5-21.86c0-.34-.08-.69-.14-1 0-.35-.12-.7-.2-1a21.29 21.29 0 0 0-6.12-10.88s-.05 0-.06-.06a22.11 22.11 0 0 0-2.62-2.1 21.43 21.43 0 0 1 7.65 4.65s0 0 .05.05a21.42 21.42 0 0 1 6.16 10.99Z",
    style: {
      fill: "url(#logo_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.2 154.91-7.12-13.34c-5.58-10.61-18.26-15.67-29.95-14.33L131 143.12a19 19 0 0 1-15.26-5.35l-.25-.24a21.94 21.94 0 0 0 15.91 1.71l124.87-34.05c13.54-3.6 21 5 29.5 13.79a56 56 0 0 1 16.43 35.93Z",
    style: {
      fill: "url(#logo_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.93 170.65A21.37 21.37 0 0 1 216.37 189l-66.46 18.12a21.56 21.56 0 0 1-12.64-.34 21 21 0 0 0 8.91 1.24l69.11-5.13a21.28 21.28 0 0 0 16.64-32.19Z",
    style: {
      fill: "url(#logo_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h354.67v354.67H0z"
  }));
};

export default SvgLogo;